/**
 * Centralized locale / currency / date config for Talent Junction US.
 * Single source of truth — import from here in any component that formats a value.
 */
export const LOCALE = "en-US";
export const CURRENCY = "USD";
export const CURRENCY_SYMBOL = "$";
export const DATE_FORMAT = "MM/dd/yyyy";
export const TIME_FORMAT = "h:mm a";
export const PHONE_FORMAT = "US";
export const COUNTRY = "United States";

/** Format a monetary amount in USD, e.g. formatCurrency(290) → "$290" */
export function formatCurrency(amount, opts = {}) {
  const n = Number(amount || 0);
  const cents = opts.cents === true;
  const fractionDigits = cents || n % 1 !== 0 ? 2 : 0;
  const formatted = new Intl.NumberFormat(LOCALE, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: 2,
  }).format(n);
  return `${CURRENCY_SYMBOL}${formatted}`;
}

/** Format a date as MM/DD/YYYY. */
export function formatDate(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime?.())) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${d.getFullYear()}`;
}

/** Format a datetime as MM/DD/YYYY h:mm AM/PM (12h). */
export function formatDateTime(iso) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime?.())) return "—";
  const datePart = formatDate(d);
  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${datePart} ${hours}:${minutes} ${ampm}`;
}
